<div [ngClass]="{'potentially-overdrawn': potentiallyOverdrawn, 'overdrawn': overdrawn}">
    <progressbar [max]="total" [value]="stack" class="progress"></progressbar>
    <div *ngIf="showRemaining || showCeilingLabel">
        <div class="row">
            <div *ngIf="showRemaining" class="col remaining-div">
                <div *ngIf="!overdrawn" class="remaining-normal">
                    {{ remaining | currency:'CAD':'symbol-narrow':'1.2-2' }} {{ remainingText }}
                </div>

                <div *ngIf="overdrawn" class="remaining-overdrawn">
                    {{ overdrawnText }} {{ remaining | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </div>
                <div *ngIf="potentiallyOverdrawn && !overdrawn" class="remaining-potentially-overdrawn">
                    {{ potentiallyOverdrawnText }} {{ potentiallyRemaining | currency:'CAD':'symbol-narrow':'1.2-2' }}
                </div>
            </div>
            <div *ngIf="showCeilingLabel" class="col text-end ceiling-label-div">
                {{ ceiling | currency:'CAD':'symbol-narrow':'1.2-2' }} {{ ceilingLabelText }}
            </div>
        </div>
    </div>
    <div *ngIf="showLegend" class="legend-div">
        <ul class="legend-ul">
            <li *ngFor="let legendItem of legend" [ngClass]="legendItem.type" class="legend-li">
                {{ legendItem.amount | currency:'CAD':'symbol-narrow':'1.2-2' }} {{ legendItem.text }}
            </li>
        </ul>
        <span *ngIf="showCreditAllocationExplanation" class="credits-explanation">
            {{ creditAllocationExplanationText }}
        </span>
    </div>
</div>
